module.exports = __webpack_public_path__ + "static/media/video1-ipswich.f6dba197.mp4";